import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Paper,
  Typography,
  Box,
  Button,
  Chip,
  Tooltip,
  LinearProgress,
} from "@mui/material";
import { display } from "../Brand/index";

// On Row Click Make an API call
const ArchiveHistoryTable = ({
  runSummaries,
  setRefreshSummary,
  handleRowClick,
}) => {
  runSummaries = runSummaries.map((summary) => {
    let metadataString;

    if (!summary.history_data || !Array.isArray(summary.history_data)) {
      metadataString = "";
    } else {
      metadataString = summary.history_data
        .map((item) => {
          return Object.entries(item)
            .filter(([key, value]) => value !== null && value !== undefined)
            .map(([key, value]) => value.toString().toLowerCase())
            .join(" ");
        })
        .join(" ");
    }

    return {
      ...summary,
      metadataString: metadataString,
    };
  });

  const numberOfMatches = (words, stringifiedObject) => {
    return words.reduce((hits, word) => {
      if (stringifiedObject.indexOf(word) !== -1) {
        return hits + 1;
      }
      return hits;
    }, 0);
  };

  const squashString = (searchString) =>
    searchString.replace(/\s+/g, " ").toLowerCase();

  const stringifyObject = (obj) => {
    const objectString = JSON.stringify(obj);

    return squashString(objectString);
  };

  const superSearch = (searchString, searchObject) => {
    // Look for all the words one by one
    const words = searchString.split(" ");
    const stringifiedObject = stringifyObject(searchObject);
    const fullMatch =
      stringifiedObject.indexOf(squashString(searchString)) !== -1;

    return {
      fullMatch,
      numberOfMatches: numberOfMatches(words, stringifiedObject),
    };
  };

  // Define columns for the data table
  const columns = [
    {
      name: "started_at",
      label: "Started At",
      options: {
        customBodyRender: (value) => new Date(value).toLocaleString(),
      },
    },
    {
      name: "username",
      label: "User",
    },
    {
      name: "notes",
      label: "Note",
    },
    {
      name: "metadata_id",
      label: "Metadata ID",
      options: {
        display: false,
      },
    },
    {
      name: "roster_id",
      label: "Roster ID",
      options: {
        display: false,
      },
    },
    {
      name: "product_ids",
      label: "Product IDs",
      options: {
        display: false,
      },
    },
    {
      name: "Audible Type",
      label: "Audible Type",
      options: {
        customBodyRender: (value, tableMeta) => {
          // Get progress and total from the row data
          const rowData = tableMeta.rowData;
          const rowIndex = tableMeta.rowIndex;

          if (
            runSummaries[rowIndex].metadata_id &&
            runSummaries[rowIndex].metadata_id != ""
          ) {
            return (
              <Typography variant="caption">
                Archive By Product Metadata
              </Typography>
            );
          } else if (
            runSummaries[rowIndex].product_ids &&
            runSummaries[rowIndex].product_ids != ""
          ) {
            return (
              <Typography variant="caption">Archive By Product</Typography>
            );
          } else {
            return (
              <Typography variant="caption">Archive By Athlete</Typography>
            );
          }
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (value, tableMeta) => {
          // Get progress and total from the row data
          const rowData = tableMeta.rowData;
          const rowIndex = tableMeta.rowIndex;

          // Assuming you have progress and total fields in your data
          const progress = runSummaries[rowIndex].progress || 0;
          const total = runSummaries[rowIndex].total || 0;

          // Calculate percentage
          const percentage =
            total && total != 0 ? Math.round((progress / total) * 100) : 100;

          // Determine color based on status
          let color = "warning";
          if (percentage == 100) {
            color = "success";
          } else if (percentage == 0) {
            color = "error";
          }

          return (
            <Box
              sx={{ width: "100%" }}
              onClick={() => {
                console.log(`summary`, runSummaries[rowIndex]);
                handleRowClick(runSummaries[rowIndex]);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Chip label={value} color={color} size="small" />
                <Typography variant="caption">{`${progress}/${total} (${percentage}%)`}</Typography>
              </Box>
              <Tooltip title={`${percentage}% complete`}>
                <LinearProgress
                  variant="determinate"
                  value={percentage}
                  color={color}
                  sx={{ height: 8, borderRadius: 1 }}
                />
              </Tooltip>
            </Box>
          );
        },
      },
    },
    {
      name: "metadataString",
      label: "Metadata String",
      options: {
        filter: true,
        sort: true,
        display: "false",
      },
    },
  ];

  // MUIDataTable options
  const options = {
    responsive: "standard",
    selectableRows: "none",
    print: false,
    download: true,
    viewColumns: true,
    filter: true,
    filterType: "dropdown",
    pagination: true,
    rowsPerPage: 10,
    customSearch: (searchText, row) =>
      superSearch(searchText.toLowerCase(), { ...row }).numberOfMatches > 0,
    rowsPerPageOptions: [5, 10, 15, 20],
    textLabels: {
      body: {
        noMatch: "No operation summaries found",
      },
    },
    customBodyRender: (value, tableMeta) => {
      const id = tableMeta.rowData[0];
      const isSelected = !!selectedCollections.find(
        (collection) => collection.CollectionId === id
      );
      return (
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleRowClick(tableMeta.rowData)}
        />
      );
    },
  };

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h6">Audible History</Typography>
        <Button
          variant="outlined"
          onClick={() => setRefreshSummary((prev) => !prev)}
        >
          Refresh
        </Button>
      </Box>

      <MUIDataTable
        title=""
        data={runSummaries}
        columns={columns}
        options={options}
      />
    </Paper>
  );
};

export default ArchiveHistoryTable;
